'use client';

import { useEffect, useState } from 'react';
import {
  DispensaryLocations,
  FAQSection,
  Header,
  PageShowcasesProvider,
  RecentDealsSection,
  ReviewsSection,
  SponsoredBanners,
  SponsoredBannersProvider,
} from '@/components';
import ProductShowcaseSection from '@/components/sections/ProductShowcaseSection';
import DankLifestyleSection from '@/components/sections/DankLifestyleSection';
import WhyDankDeliverySection from '@/components/sections/WhyDankDeliverySection';
import CategorySection from '@/components/sections/CategorySection';
import DeliveryComparisonSection from '@/components/sections/DeliveryComparisonSection';
import {
  SamedayHeroSection,
  CalgaryWeedDeliverySection,
  CalgaryDeliveryServiceSection,
  WhereWeDeliverSection,
  MapAboutCalgarySection,
  HowOurDeliveryWorksSection,
  LiveOrderTrackingSection,
  CalgaryBestDispensarySection,
  SamedaySeoBlocksSection,
} from '@/components/sections/sameday-delivery';
import type { Store } from '@/lib/types/stores';
import { DEFAULT_CATEGORY_TILES as categories } from "@/lib/category-tiles";

const API_BASE = process.env.NEXT_PUBLIC_API_BASE_URL || 'http://localhost:4000';


export default function SameDayDeliveryPage() {
  const [stores, setStores] = useState<Store[]>([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/api/stores`, { cache: 'no-store' });
        if (res.ok) {
          const data = await res.json();
          if (data?.stores) setStores(data.stores);
        }
      } catch {
        // ignore
      }
    })();
  }, []);

  return (
    <SponsoredBannersProvider>
      <PageShowcasesProvider endpoint="/api/sameday-delivery/product-showcases">
        <div className="min-h-screen w-full min-w-0 max-w-none">
          <Header stores={stores} base={API_BASE} />

          <main className="home-page w-full max-w-none pb-16 py-4 sm:py-6">
            <div className="w-full max-w-none space-y-16 px-4 sm:space-y-36 sm:px-8 [&>section]:!px-0">
              <SamedayHeroSection />

              <CalgaryWeedDeliverySection />

              <ProductShowcaseSection slotKey="afterHero" />

              <div className="flex w-full max-w-none flex-col gap-6 lg:gap-10 [&>section]:!px-0">
                <CalgaryDeliveryServiceSection />

                <section className="w-full max-w-none" aria-label="Sponsored content">
                  <SponsoredBanners position="sameday-delivery-1" limit={1} className="w-full" />
                </section>
              </div>

              <WhereWeDeliverSection />

              <MapAboutCalgarySection />

              <WhyDankDeliverySection />

              <ProductShowcaseSection slotKey="afterPopularBrands" />

              <DispensaryLocations base={API_BASE} />

              <CategorySection categories={categories as any} contentClassName="!px-0" />

              <HowOurDeliveryWorksSection />

              <LiveOrderTrackingSection />

              <ReviewsSection />

              <CalgaryBestDispensarySection />

              <RecentDealsSection />

              <SamedaySeoBlocksSection />

              <DankLifestyleSection apiPath="/api/how-delivery-works/merch" />

              <section className="w-full max-w-none" aria-label="Sponsored content">
                <SponsoredBanners position="sameday-delivery-3" limit={1} className="w-full" />
              </section>

              <FAQSection sponsoredPosition="sameday-delivery-4" />
            </div>
          </main>
        </div>
      </PageShowcasesProvider>
    </SponsoredBannersProvider>
  );
}
